<template>
  <div id="hzfws">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'hzfws'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/exhibitors/hzfws/Hzfws.vue